/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import get from 'lodash/get';
import { withNamespaces } from 'react-i18next';
import compose from 'lodash/fp/compose';
import {
  Text,
  Placeholder,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import { Row, Column, MediaQueries } from '../../../../styles/Grid';
import { showElementCss } from '../../../../utils/responsive';
import { COMPONENT_NAMES, NAVBAR_IDS } from '../../../../utils/constants';
import getComponent from '../../../../utils/getComponent';
import { buttonReset } from '../Nav/index.styles';
import createButtonCss from '../../../ui/Button/Button';
import { modalIds, ModalsConsumer } from '../../../../contexts/ModalsContext';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { onClickNavigationItem } from '../WaysToWork';
import LinkWrapper from '../../../ui/LinkWrapper';
import {
  rightColumnCss,
  leftColumnCss,
  firstTitleCss,
  firstDescriptionCss,
  secondTitleCss,
  secondDescriptionCss,
  rowGetInTouchCss,
  listOfWaysToWorkCss,
  waysToWorkItemCss,
  waysToWorkButtonCss,
  waysToWorkTextCss,
  phoneNumberCss,
} from './index.styles';

class Contact extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const { fields } = this.props;
    const { sitecoreContext } = props;
    const navBarComponent = getComponent(
      sitecoreContext,
      COMPONENT_NAMES.navBar,
    );
    const getInTouchCta = get(navBarComponent, 'fields.GetInTouchCTA', {});
    const getInTouchCtaHref = get(getInTouchCta, 'value.href', '');
    const waysToWorkItems = get(props.fields, 'NavigationItems.value', []);
    const shouldOpenCtaAsPage = Boolean(getInTouchCtaHref);
    const { t } = props;

    return (
      <React.Fragment>
        <Column
          css={leftColumnCss}
          cols={{ sm: 6, md: 6, lg: 10, xl: 9 }}
          offsets={{ md: 1, lg: 0 }}
        >
          <Row css={rowGetInTouchCss}>
            <Column cols={{ sm: [6, 6], md: [6, 6], lg: [10, 10], xl: [7, 9] }}>
              <p css={firstTitleCss}>
                <Text field={fields.FirstTitle} />
              </p>
              <p css={firstDescriptionCss}>
                <Text field={fields.FirstDescription} />
              </p>
              <div css={phoneNumberCss}>
                <Placeholder
                  name="jss-phone"
                  rendering={props.rendering}
                  params={{
                    alternateIcon: true,
                    phoneNumberId: NAVBAR_IDS.PHONE_NUMBER,
                  }}
                />
              </div>
            </Column>
          </Row>

          <Row>
            <Column cols={{ sm: [6, 6], md: [6, 6], lg: [8, 10], xl: [5, 9] }}>
              <p css={secondTitleCss}>
                <Text field={fields.SecondTitle} />
              </p>
              <p css={secondDescriptionCss}>
                <Text field={fields.SecondDescription} />
              </p>
              <Row>
                <Column
                  cols={{ sm: [4, 6], md: [3, 6], lg: [3, 8], xl: [2, 5] }}
                >
                  {shouldOpenCtaAsPage ? (
                    <LinkWrapper
                      id={NAVBAR_IDS.GET_IN_TOUCH}
                      field={getInTouchCta}
                    />
                  ) : (
                    <ModalsConsumer>
                      {({ openModal }) => (
                        <button
                          id={NAVBAR_IDS.GET_IN_TOUCH}
                          onClick={() => openModal(modalIds.enquiry)}
                          css={createButtonCss()}
                        >
                          {t('GetInTouchCTA')}
                        </button>
                      )}
                    </ModalsConsumer>
                  )}
                </Column>
              </Row>
            </Column>
          </Row>
        </Column>
        <Column
          css={[rightColumnCss, showElementCss(MediaQueries.xl, 'flex')]}
          cols={{ xl: 3 }}
        >
          <ul css={listOfWaysToWorkCss}>
            {waysToWorkItems.map(item => {
              return (
                <li css={waysToWorkItemCss} key={item.fields.id}>
                  <button
                    css={[buttonReset, waysToWorkButtonCss]}
                    id={item.fields.id}
                    onClick={event =>
                      onClickNavigationItem(event, waysToWorkItems)
                    }
                    aria-label={item.fields.Label.value}
                  >
                    <p css={waysToWorkTextCss}>{item.fields.Label.value}</p>
                  </button>
                </li>
              );
            })}
          </ul>
        </Column>
      </React.Fragment>
    );
  }
}

Contact.displayName = 'NavBar/Contact';

Contact.defaultProps = {
  t: key => key,
};

export default compose(withSitecoreContext(), withNamespaces())(Contact);
